module.exports = __webpack_public_path__ + "img/2.2a17cca5.png";